/**
 * Mainbeauty — vẽ lại số chỗ webinar ngay sau khi giữ chỗ thành công.
 * Con số lấy từ gói `seats` trong phản hồi của plugin Leads (server đếm lại DB),
 * nên nếu có người khác vừa đăng ký xen vào thì khách vẫn thấy đúng số còn lại.
 *
 * 🚨 Vẽ đúng VÙNG của buổi vừa đăng ký, không vẽ cả trang: trang chủ có nhiều buổi cùng lúc
 * (dải thẻ webinar + đồng hồ đếm ngược), nên vẽ tràn là dán số chỗ của buổi này lên thẻ của
 * buổi khác. Vùng là [data-pi-seats-for="<id buổi>"]. Không kèm id, hoặc trang không có vùng
 * nào mang id đó, thì lùi về vẽ cả trang — trang chi tiết một buổi chỉ có đúng một buổi.
 */

function scopes(id) {
  const found = id ? document.querySelectorAll(`[data-pi-seats-for="${id}"]`) : [];
  return found.length ? Array.from(found) : [document];
}

function queryAll(roots, selector) {
  return roots.flatMap((root) => Array.from(root.querySelectorAll(selector)));
}

// Khóa của [data-pi-seats] trùng khóa trong gói `seats`: taken · total · left.
function paintNumbers(roots, seats) {
  queryAll(roots, "[data-pi-seats]").forEach((node) => {
    const value = seats[node.dataset.piSeats];
    if (value !== undefined) node.textContent = value;
  });
}

// Thanh <progress data-pi-seats-bar> (landing page) theo số chỗ còn lại.
function paintBars(roots, seats) {
  if (!seats.total) return;
  queryAll(roots, "[data-pi-seats-bar]").forEach((node) => {
    node.max = seats.total;
    node.value = seats.left ?? 0;
  });
}

// Chỗ cuối cùng vừa bị lấy → đổi "Chỉ còn N chỗ" thành "Đã hết chỗ".
function paintState(roots, full) {
  queryAll(roots, "[data-pi-seats-open]").forEach((node) => (node.hidden = full));
  queryAll(roots, "[data-pi-seats-full]").forEach((node) => (node.hidden = !full));
}

document.addEventListener("pi:lead", (e) => {
  const seats = e.detail?.response?.seats;
  if (!seats) return; // form khác webinar — không đụng tới số chỗ

  const roots = scopes(e.detail?.webinarId);
  paintNumbers(roots, seats);
  paintBars(roots, seats);
  paintState(roots, Boolean(seats.full));
});
